
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("bqjR5", function(module, exports) {

$parcel$export(module.exports, "i18n", () => $b15bfa4335ef62c1$export$a7357cdd1f0b0168);
$parcel$export(module.exports, "PoweredByTemplates", () => $b15bfa4335ef62c1$export$a580dab1b138f630);
/* PoweredByTemplates.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $35pXk = parcelRequire("35pXk");

var $9wGTI = parcelRequire("9wGTI");

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $lGgRw = parcelRequire("lGgRw");

var $eEA8O = parcelRequire("eEA8O");

var $dIouf = parcelRequire("dIouf");

var $8uZoP = parcelRequire("8uZoP");

var $lsi61 = parcelRequire("lsi61");
const $b15bfa4335ef62c1$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    poweredByTemplates: {
        id: "powered-by-templates.byline.text",
        defaultMessage: "with a template"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b15bfa4335ef62c1$var$PoweredByBylineWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0c1o8l _syaz131l _1a3b18uv _4fpr8stv _5goinqa1 _9oik18uv _1bnx8stv _jf4cnqa1 _8kwo18uv _1vwxglyw _2gcsnqa1 _d0altlke",
            __cmplp.className
        ])
    });
});
const $b15bfa4335ef62c1$export$a580dab1b138f630 = ({ templateId: templateId })=>{
    const { isPopupOpen: isPopupOpen, startOpenPopupTimer: startOpenPopupTimer, startClosePopupTimer: startClosePopupTimer } = (0, $8uZoP.useHoverPoweredByPopup)();
    const containerListeners = {
        onMouseLeave: startClosePopupTimer,
        onMouseEnter: startOpenPopupTimer,
        onKeyDown: startOpenPopupTimer,
        onBlur: startClosePopupTimer
    }; /** Uses a custom popup container because the template card has its own wrapper container. */ 
    const CustomPopupContainer = /*#__PURE__*/ (0, $gwFzn.forwardRef)((props, ref)=>{
        const { style: style, children: children, ...extraProps } = props;
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
            ...extraProps,
            ref: ref,
            style: style
        }, children));
    });
    const PopupContent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", containerListeners, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lsi61.PoweredByTemplatesPopup), {
            templateId: templateId
        }));
    const TriggerComponent = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($b15bfa4335ef62c1$var$PoweredByBylineWrapper, {
            ...triggerProps,
            ...containerListeners,
            "data-testid": "powered-by-byline"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eEA8O.default), {
            appearance: "subtle-link",
            spacing: "none" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
            ,
            style: {
                fontWeight: 'unset'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $b15bfa4335ef62c1$export$a7357cdd1f0b0168.poweredByTemplates)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).TAILORED_EXPERIENCES
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lGgRw.default), {
        isOpen: isPopupOpen,
        onClose: startClosePopupTimer,
        content: PopupContent,
        trigger: TriggerComponent,
        placement: "bottom-start",
        popupComponent: CustomPopupContainer,
        autoFocus: false,
        offset: [
            -8,
            0
        ],
        shouldRenderToParent: (0, $9wGTI.fg)('should-render-to-parent-should-be-truetailored-exp')
    }));
};

});
parcelRegister("8uZoP", function(module, exports) {

$parcel$export(module.exports, "useHoverPoweredByPopup", () => $dbaf01e788d0f5a1$export$58e5567e426c3933);

var $gwFzn = parcelRequire("gwFzn");
const $dbaf01e788d0f5a1$export$d69115035f1165c9 = 400;
const $dbaf01e788d0f5a1$export$a9c55daea77bba84 = 200;
const $dbaf01e788d0f5a1$export$58e5567e426c3933 = ()=>{
    const [isPopupOpen, setPopupOpen] = (0, $gwFzn.useState)(false);
    const openPopupTimerRef = (0, $gwFzn.useRef)(null);
    const closePopupTimerRef = (0, $gwFzn.useRef)(null);
    const openPopup = (0, $gwFzn.useCallback)(()=>{
        setPopupOpen(true);
    }, [
        setPopupOpen
    ]);
    const closePopup = (0, $gwFzn.useCallback)(()=>{
        setPopupOpen(false);
    }, [
        setPopupOpen
    ]);
    const _clearOpenPopupTimer = (0, $gwFzn.useCallback)(()=>{
        if (openPopupTimerRef?.current) {
            clearTimeout(openPopupTimerRef.current);
            openPopupTimerRef.current = null;
        }
    }, [
        openPopupTimerRef
    ]);
    const _clearClosePopupTimer = (0, $gwFzn.useCallback)(()=>{
        if (closePopupTimerRef?.current) {
            clearTimeout(closePopupTimerRef.current);
            closePopupTimerRef.current = null;
        }
    }, [
        closePopupTimerRef
    ]);
    const _clearAllTimers = (0, $gwFzn.useCallback)(()=>{
        _clearOpenPopupTimer();
        _clearClosePopupTimer();
    }, [
        _clearOpenPopupTimer,
        _clearClosePopupTimer
    ]);
    const _setOpenPopupTimer = (0, $gwFzn.useCallback)(()=>{
        if (openPopupTimerRef?.current === null) openPopupTimerRef.current = setTimeout(()=>{
            openPopup();
            openPopupTimerRef.current = null;
        }, $dbaf01e788d0f5a1$export$d69115035f1165c9);
    }, [
        openPopup
    ]);
    const _setClosePopupTimer = (0, $gwFzn.useCallback)(()=>{
        if (closePopupTimerRef?.current === null) closePopupTimerRef.current = setTimeout(()=>{
            closePopup();
            closePopupTimerRef.current = null;
        }, $dbaf01e788d0f5a1$export$a9c55daea77bba84);
    }, [
        closePopup
    ]);
    const startOpenPopupTimer = ()=>{
        _clearAllTimers();
        _setOpenPopupTimer();
    };
    const startClosePopupTimer = ()=>{
        _clearAllTimers();
        _setClosePopupTimer();
    };
    return {
        isPopupOpen: isPopupOpen,
        startOpenPopupTimer: startOpenPopupTimer,
        startClosePopupTimer: startClosePopupTimer
    };
};

});

parcelRegister("lsi61", function(module, exports) {

$parcel$export(module.exports, "PoweredByTemplatesPopup", () => $bfb8d26a5ab8e357$export$e26761bd18c8148e);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");

var $diswb = parcelRequire("diswb");

var $inPa6 = parcelRequire("inPa6");

var $dIouf = parcelRequire("dIouf");

var $7Sm4c = parcelRequire("7Sm4c");

var $uUYY8 = parcelRequire("uUYY8");
var $ab51d = parcelRequire("ab51d");
var $6WUhQ = parcelRequire("6WUhQ");
const $bfb8d26a5ab8e357$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    viewButton: {
        id: "powered-by-templates.popup.view-template-button",
        defaultMessage: "View"
    }
});
/**
 * The **popup** component for Powered By.
 * Returns a {@linkcode PoweredByTemplateCard} filled with information about the template used on the page.
 * @param templateId The page's source template key.
 * @constructor
 */ const $bfb8d26a5ab8e357$var$Component = ({ templateId: templateId })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { data: data, loading: loading, error: error } = (0, $diswb.useQuery)((0, $d2LG0.default)`query PoweredByTemplatesPopupTemplateInfoQuery($templateId:ID!){templateInfo(id:$templateId){name author description iconURL darkModeIconURL styleClass templateId itemModuleCompleteKey blueprintModuleCompleteKey contentBlueprintId spaceKey}}`, {
        variables: {
            templateId: templateId
        }
    });
    (0, $gwFzn.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'poweredByTemplatePopup',
                source: 'viewPageScreen',
                attributes: {
                    templateId: templateId
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        templateId
    ]);
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6WUhQ.PoweredByTemplateLoadingCard), {
        "data-testid": "powered-by-template-loading-test-id"
    });
    if (error) {
        if ((0, $dIouf.isUnauthorizedError)(error)) {
            (0, $7Sm4c.markErrorAsHandled)(error);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ab51d.PoweredByTemplateErrorCard), {
                errorState: "permission"
            });
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
            error: error
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ab51d.PoweredByTemplateErrorCard), {
            errorState: "unknown"
        }));
    }
    const templateObject = data?.templateInfo;
    if (!templateObject) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ab51d.PoweredByTemplateErrorCard), {
        errorState: "deleted"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $uUYY8.PoweredByTemplateCard), {
        template: templateObject
    });
};
const $bfb8d26a5ab8e357$export$e26761bd18c8148e = /*#__PURE__*/ (0, $gwFzn.memo)($bfb8d26a5ab8e357$var$Component);

});
parcelRegister("uUYY8", function(module, exports) {

$parcel$export(module.exports, "ItemWrapper", () => $36493a418eec6441$export$ef9839ae55b8ba40);
$parcel$export(module.exports, "PoweredByTemplateCard", () => $36493a418eec6441$export$ae0109f8c975a646);
/* PoweredByTemplateCard.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $eEA8O = parcelRequire("eEA8O");

var $inPa6 = parcelRequire("inPa6");

var $1NBp8 = parcelRequire("1NBp8");

var $10Oe6 = parcelRequire("10Oe6");

var $7Wf9U = parcelRequire("7Wf9U");
const $36493a418eec6441$var$i18n = (0, $2nPZH.defineMessages)({
    viewButton: {
        id: "template-card.powered-by-template-card.view-button",
        defaultMessage: "View"
    },
    authorLabel: {
        id: "template-card.powered-by-template-card.author-label",
        defaultMessage: "by {author}"
    }
});
const $36493a418eec6441$export$ef9839ae55b8ba40 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_2rko1l7b _1yt4v47k _18s8u2gc _v56414ba _vchhusvi _4t3i1osq _1bsbnklw _bfhk1bhr _80om1wug _1e0c1txw _2lx21bp4 _1bah1yb4 _16qs1cd0",
            __cmplp.className
        ])
    });
});
const $36493a418eec6441$var$HeaderWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1bsb1osq _otyrutpp _1e0c1txw _4cvr1y6m _1bah1yb4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $36493a418eec6441$var$LogoAndAuthorWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _4t3i1ylp _1e0c1txw _4cvresu3 _1bah1yb4",
            __cmplp.className
        ])
    });
});
const $36493a418eec6441$var$AuthorName = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_11c8dcr7 _1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _i0dlf1ug _18u0u2gc _syaz1gjq _1e0ccj1k _1yyjcs5v _sudp1e54 _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $36493a418eec6441$var$TemplateName = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_11c8lodh _1reo15vq _18m915vq _otyru2gc _1e0ccj1k _1yyjcs5v _sudp1e54 _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $36493a418eec6441$var$DescriptionWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_11c8dcr7 _1reo15vq _18m915vq _otyrutpp _1e0ccj1k _1yyj11wp _sudp1e54 _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $36493a418eec6441$var$ViewButtonWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1wpzesu3",
            __cmplp.className
        ])
    });
});
const $36493a418eec6441$export$ae0109f8c975a646 = ({ template: template })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { name: name, author: author, spaceKey: spaceKey, blueprintModuleCompleteKey: blueprintModuleCompleteKey } = template;
    const isAuthorFieldEnabled = author && blueprintModuleCompleteKey;
    const templateGalleryURL = (0, $1NBp8.TEMPLATE_GALLERY).toUrl({}, {
        query: {
            space: spaceKey,
            template: (0, $10Oe6.getTemplateKey)(template),
            flow: 'poweredBy'
        }
    });
    const fireAnalytics = (0, $gwFzn.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'poweredBy',
                action: 'clicked',
                actionSubject: 'viewButton',
                actionSubjectId: 'poweredBy',
                attributes: {
                    ...(0, $10Oe6.getTemplateIdAttributesForAnalytics)(template)
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        template
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($36493a418eec6441$export$ef9839ae55b8ba40, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($36493a418eec6441$var$HeaderWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($36493a418eec6441$var$LogoAndAuthorWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7Wf9U.TemplateIcon), {
        template: template,
        size: "large"
    }), isAuthorFieldEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($36493a418eec6441$var$AuthorName, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        values: {
            author: author
        },
        ...$36493a418eec6441$var$i18n.authorLabel
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($36493a418eec6441$var$TemplateName, null, name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($36493a418eec6441$var$DescriptionWrapper, null, template.description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($36493a418eec6441$var$ViewButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eEA8O.default), {
        appearance: "primary",
        onClick: fireAnalytics,
        href: templateGalleryURL
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $36493a418eec6441$var$i18n.viewButton))));
};

});

parcelRegister("ab51d", function(module, exports) {

$parcel$export(module.exports, "PoweredByTemplateErrorCard", () => $64a1ff4e458729f0$export$67f8ac4652ad3290);
/* PoweredByTemplateErrorCard.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $uUYY8 = parcelRequire("uUYY8");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $64a1ff4e458729f0$var$TemplateErrorHeadingWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_11c82smr _k48p1pd9 _syaz1gjq _otyru2gc _1wpz1h6o",
            __cmplp.className
        ])
    });
});
const $64a1ff4e458729f0$var$TemplateErrorDescriptionWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_syaz131l _1wpz1h6o",
            __cmplp.className
        ])
    });
});
const $64a1ff4e458729f0$var$i18n = (0, $2nPZH.defineMessages)({
    templateDeletedHeading: {
        id: "template-card.powered-by-template-card.template-deleted-heading",
        defaultMessage: "Well, this is awkward..."
    },
    templateDeletedDescription: {
        id: "template-card.powered-by-template-card.template-deleted-description",
        // TODO: replace straight quotes with curly quotes (see go/curlyquotes)
        // eslint-disable-next-line no-restricted-syntax
        defaultMessage: "That template's been deleted"
    },
    unknownErrorHeading: {
        id: "template-card.powered-by-template-card.unknown-error-heading",
        // TODO: replace straight quotes with curly quotes (see go/curlyquotes)
        // eslint-disable-next-line no-restricted-syntax
        defaultMessage: "Can't load template"
    },
    unknownErrorDescription: {
        id: "template-card.powered-by-template-card.unknown-error-description",
        defaultMessage: "Try refreshing the page"
    },
    permissionErrorHeading: {
        id: "template-card.powered-by-template-card.permission-error-heading",
        defaultMessage: "Well, this is awkward..."
    },
    permissionErrorDescription: {
        id: "template-card.powered-by-template-card.permission-error-description",
        // TODO: replace straight quotes with curly quotes (see go/curlyquotes)
        // eslint-disable-next-line no-restricted-syntax
        defaultMessage: "You can't use this template."
    }
});
const $64a1ff4e458729f0$var$resolveErrorMessage = (templateError)=>{
    switch(templateError){
        case 'deleted':
            return {
                errorHeading: $64a1ff4e458729f0$var$i18n.templateDeletedHeading,
                errorDescription: $64a1ff4e458729f0$var$i18n.templateDeletedDescription
            };
        case 'permission':
            return {
                errorHeading: $64a1ff4e458729f0$var$i18n.permissionErrorHeading,
                errorDescription: $64a1ff4e458729f0$var$i18n.permissionErrorDescription
            };
        default:
            return {
                errorHeading: $64a1ff4e458729f0$var$i18n.unknownErrorHeading,
                errorDescription: $64a1ff4e458729f0$var$i18n.unknownErrorDescription
            };
    }
};
const $64a1ff4e458729f0$export$67f8ac4652ad3290 = ({ errorState: errorState })=>{
    const { errorHeading: errorHeading, errorDescription: errorDescription } = $64a1ff4e458729f0$var$resolveErrorMessage(errorState);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $uUYY8.ItemWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($64a1ff4e458729f0$var$TemplateErrorHeadingWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), errorHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($64a1ff4e458729f0$var$TemplateErrorDescriptionWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), errorDescription)));
};

});

parcelRegister("6WUhQ", function(module, exports) {

$parcel$export(module.exports, "PoweredByTemplateLoadingCard", () => $bb79660b19bb4b05$export$fc45bbb0826399b3);
/* PoweredByTemplateLoadingCard.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $uUYY8 = parcelRequire("uUYY8");
const $bb79660b19bb4b05$export$fc45bbb0826399b3 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = (0, $uUYY8.ItemWrapper), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_4t3iuuw1",
            __cmplp.className
        ])
    });
});

});




//# sourceMappingURL=PoweredByTemplates.2d75c901.js.map
